var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableReservedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9896 15.3522L19.3742 5.38933C19.3107 4.99824 18.9731 4.71085 18.5769 4.71085H3.11836L3.24936 5.51853L3.38033 6.32621L4.7338 14.6737L4.8648 15.4814L4.99577 16.2891H20.1923C20.3093 16.2891 20.4249 16.2636 20.5311 16.2146C20.6373 16.1655 20.7316 16.0939 20.8074 16.0048C20.8832 15.9157 20.9388 15.8112 20.9702 15.6986C21.0017 15.5859 21.0083 15.4677 20.9896 15.3522ZM16.1538 11.3077H8.07686C7.63082 11.3077 7.26918 10.946 7.26918 10.5C7.26918 10.0539 7.63082 9.69236 8.07686 9.69236H16.1538C16.5998 9.69236 16.9615 10.054 16.9615 10.5C16.9615 10.946 16.5999 11.3077 16.1538 11.3077ZM3.22824 15.4814L3.09728 14.6737L2.42708 10.5402L2.01795 8.01703L1.60882 5.49379L0.0104 15.3521C-0.00831457 15.4676 -0.00171542 15.5858 0.029741 15.6985C0.0611973 15.8112 0.11676 15.9157 0.192585 16.0048C0.26841 16.0939 0.362687 16.1655 0.468895 16.2146C0.575102 16.2636 0.690704 16.2891 0.807703 16.2891H3.35924L3.22824 15.4814Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableReservedIcon);
export default __webpack_public_path__ + "static/media/table-reserved-icon.eaa04d6e57bf541625096cf81dd1b457.svg";
export { ForwardRef as ReactComponent };